export const DOCUMENT_REDIRECT_URL =
  "https://congpt.s3.eu-north-1.amazonaws.com/KCS_PDFs";

export const months = [
  "1월", // January
  "2월", // February
  "3월", // March
  "4월", // April
  "5월", // May
  "6월", // June
  "7월", // July
  "8월", // August
  "9월", // September
  "10월", // October
  "11월", // November
  "12월", // December
];

export const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const webCurrency = "￦";
export interface IPAYMENT_OBJECT_KEYS {
  EMAIL: string;
  CARD_NUMBER: string;
  MMYY: string;
  CVV: string;
  CARD_HOLDER_NAME: string;
  COUNTRY: string;
  ADDRESS: string;
  CITY: string;
  STATE: string;
  ZIP_CODE: string;
}
export const PAYMENT_OBJECT_KEYS: IPAYMENT_OBJECT_KEYS = {
  EMAIL: "email",
  CARD_NUMBER: "cardNumber",
  MMYY: "expires",
  CVV: "cvv",
  CARD_HOLDER_NAME: "cardHolderName",
  COUNTRY: "country_region",
  ADDRESS: "address",
  CITY: "city",
  STATE: "state",
  ZIP_CODE: "zip_code",
};
export const PAYMENT_OBJECT_KEYS_REGEX = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, // Matches standard email formats
  CARD_NUMBER: /^\d{16}$/, // Matches 16 digit card numbers
  MMYY: /^(0[1-9]|1[0-2])\/?([0-9]{2})$/, // Matches MM/YY format for expiration date
  CVV: /^\d{3,4}$/, // Matches 3 or 4 digit CVV
  CARD_HOLDER_NAME: /^[a-zA-Z\s]{2,30}$/, // Matches 2 to 30 characters for cardholder name
  COUNTRY: /^[a-zA-Z\s]{2,50}$/, // Matches country names (allowing for up to 50 characters)
  ADDRESS: /^[\w\s,#-]{5,100}$/, // Matches addresses (alphanumeric, spaces, commas, hyphens, etc.)
  CITY: /^[a-zA-Z\s]{2,50}$/, // Matches city names (allowing for up to 50 characters)
  STATE: /^[a-zA-Z\s]{2,50}$/, // Matches state names (allowing for up to 50 characters)
  ZIP_CODE: /^\d{5}(-\d{4})?$/, // Matches 5 digit ZIP codes with optional 4 digit extension
};

export const PATTERN_REGEX: any = {
  PDF: /^https?:\/\/(?:[\w-]+\.)+[a-z]{2,}(?:\/[^\s]*)*\.pdf(?:\?[\w&=]*)?$/i,
  YOUTUBE: /^https?:\/\/(?:www\.)?youtube\.com\/watch\?v=[\w-]{11}$/i,
  WEBSITE:
    /^https?:\/\/(?:[\w-]+\.)+[a-z]{2,}(?:\/[\w\-\.]*)*(?:\?[^\s#]*)?(?:#[^\s]*)?$/i,
};

export const WEB_TABLES_MAX_LIMIT = 10;
export const COMPANY_EMAIL = "admin@doaz.ai";
export const PDF = "pdf";
export const WEBSITE = "website";
export const YOUTUBE = "youtube";
export const PDF_FILE = "file";
export const MIME_PDF = "application/pdf";

export const ACTIVITIES_TYPES = {
  REQUEST: "request",
  FEEDBACK: "feedback",
  QUERY: "query",
};

export const ACTIVITIES_KEYS = {
  REQUEST: "enterprise",
  FEEDBACK: "feedback",
  QUERY: "contactUs",
};

export const USER_ROLES = {
  ADMIN: "admin",
  USER: "user",
  ADMIN_USER: "admin_user",
};

export const WEB_LANGUAGES = {
  ENGLIST: "EN",
  KOREAN: "KO",
};

// NO NEED TO TRANSLATE
export const FEEDBACK_RATINGS: string[] = [
  "All",
  "Correct Answer",
  "Comprehensible",
  "Absolute",
  "Unsafe",
  "Wrong",
  "Other",
];

// NO NEED TO TRANSLATE
export const WEB_CARD_TYPES: string[] = ["All", "credit"];
export const WEB_USER_STATUS: string[] = [
  "All",
  "active",
  "inactive",
  "pending",
];
export const DATE_FORMATS = {
  FULL: "YYYY/MM/DD HH:mm A", // 12-hour format with AM/PM
  SHORT: "YYYY/MM/DD", // Short format
  EUROPEAN: "DD/MM/YYYY", // European format
};

export const WEB_SUBSCRIPTION_TYPES = {
  PENDING: "pending",
  INACTIVE: "inactive",
  ACTIVE: "active",
};

export const MAX_CHARACTER_COUNT_FOR_QUESTIONS = 250;
export const MAX_CHARACTER_COUNT_FAQS = 250;
export const ALLOWED_FORMATS_FOR_CONTACT_US = [".png", ".jpg", ".jpeg"];
export const ALLOWED_FORMATS_FOR_CHAT = [
  "application/pdf", // PDF
  "application/msword", // DOC (older Word format)
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
  "application/vnd.ms-excel", // XLS (older Excel format)
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
  "application/vnd.ms-powerpoint", // PPT (older PowerPoint format)
  "application/vnd.openxmlformats-officedocument.presentationml.presentation", // PPTX
  "image/png", // PNG
  "image/jpeg", // JPEG
  "image/jpg", // JPG,
  "text/plain",
];

export const ALLOWED_SHORT_FORMATS_FOR_CHAT = [
  ".pdf",
  ".doc",
  ".docx",
  ".xls",
  ".xlsx",
  ".ppt",
  ".pptx",
  ".png",
  ".jpg",
  ".jpeg",
  ".txt"
];

export const USER_DASHBOARD_INPUT_NAMES = {
  RISKCHECKER: "riskCheckerInput",
  CONGPT: "conGptInput",
  DOAZGPT: "doazGptInput",
};

interface IProject {
  id: number;
  name: string;
}

type WebProjectsType = {
  CON_GPT: IProject;
  RISK_CHECKER: IProject;
  DOAZ_GPT: IProject;
  KSCE_GPT: IProject;
};

export const WEB_PROJECTS: WebProjectsType = {
  CON_GPT: {
    id: 1,
    name: "ConGPT",
  },
  RISK_CHECKER: {
    id: 2,
    name: "Riskchecker",
  },
  DOAZ_GPT: {
    id: 3,
    name: "DoazGPT",
  },
  KSCE_GPT: {
    id: 4,
    name: "KsceGPT",
  },
};

export const getProjectByID = (id: number): IProject => {
  let project = WEB_PROJECTS.CON_GPT;
  if (id) {
    switch (id) {
      case 1:
        project = WEB_PROJECTS.CON_GPT;
        break;
      case 2:
        project = WEB_PROJECTS.RISK_CHECKER;
        break;
      case 3:
        project = WEB_PROJECTS.DOAZ_GPT;
        break;
      default:
        break;
    }
  }
  return project;
};
